const passCode = ["_0", "Kje1", "019", "triEa@"];
const intCode = passCode.reverse().join("-");

export const Encript = (text: string) => {
  if (text) {
    return (window as any).CryptoJS.AES.encrypt(text, intCode).toString();
  }

  return "";
};

export const Decript = (text: string) => {
  if (text) {
    return (window as any).CryptoJS.AES.decrypt(text, intCode).toString(
      (window as any).CryptoJS.enc.Utf8
    );
  }
  return "";
};
